import { Injectable } from '@angular/core'
import { APIService } from './api.service'
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';




@Injectable()

export class FirebaseMessage {

    // httpOptions: any = {
    //     headers: new HttpHeaders({
    //         'Content-Type': 'application/json',

    //         // 'Content-Type': undefined,
    //         'Access-Control-Allow-Origin': '*'
    //     })
    // }

     httpOptions: any = {
        headers: new HttpHeaders({
         'Content-Type':  'application/json',
         'Access-Control-Allow-Origin': '*'
        })
     }

    constructor(private _http: HttpClient, private _apiServices: APIService) { }

    handleError(error: Response) {
        console.log(error);
        return Observable.throw(error);
    }

    saveMessage(message) {
        return this._http.post(environment.apiURL + "/api/saveFirebaseMessage", message)
            .catch(this.handleError);
    }

    deleteMessage(id) {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = { "id": id }
        let body = JSON.stringify(data);
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        return this._http.post(environment.apiURL + "/api/deleteFirebaseMessage", body, this.httpOptions)
            .catch(this.handleError);
    }

    messageSend(id) {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = { "id": id , "token": loginUser.token}
        let body = JSON.stringify(data);
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        return this._http.post(environment.apiURL + "/api/sendFirebaseMessageAllUsers", body, this.httpOptions)
            .catch(this.handleError);
    }
    assignMessage(Form, selectedMessageid) {
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        var isActive = Form.IsSlotAssign == true ? false : true;
        let data = { "messageid": selectedMessageid, "userid": Form.Id, "isactive": isActive, "token": loginUser.token }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/assignUserFirebaeMessage", body, this.httpOptions)
            .catch(this.handleError);
    }
    assignMessageAll(Form, selectedMessageid) {
         this.httpOptions.headers.append('Content-Type', 'application/form-data');
         this.httpOptions.headers.append('Content-Type', 'multipart/form-data');

        // this.httpOptions.headers.append('Access-Control-Allow-Origin', '*')
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        var isActive = Form.IsSlotAssign == true ? false : true;
        let data = { "messageid": selectedMessageid, "isactive": isActive, "token": loginUser.token }
        // let data = { "messageid": selectedMessageid, "users": Form, "isactive": isActive, "token": loginUser.token }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/assignUserFirebaeMessageAll", body, this.httpOptions)
            .catch(this.handleError);

    }
    getMessages() {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "token": loginUser.token
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getAllFirebaseMessage", body)
            .catch(this.handleError);
    }
    getMessagesByType(type) {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "token": loginUser.token,
            "type": type,
        }
        return this._http.post(environment.apiURL + "/api/getAllFirebaseMessageByType", data)
            .catch(this.handleError);
    }
    getPatientsFirebaseMessageList(messageid,itemsPerPage,page) {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "token": loginUser.token,
            "messageid": messageid,
            "itemsPerPage":itemsPerPage,
            "page":page
        }
        return this._http.post(environment.apiURL + "/api/getPatientsFirebaseMessageList", data)
            .catch(this.handleError);
    }
    
    uploadImage(file, userid) {
        debugger
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        const formData = new FormData();
        //formData.append('file', file);
        formData.append('files', file);
        formData.append('id', userid);
        formData.append('token', loginUser.token);
        const HttpUploadOptions = {
            headers: new HttpHeaders({
            }),
        }
        return this._http.post(environment.apiURL + "/api/uploadPatientProfileImage", formData)
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/firebasemessages.ts